import {pageInfo, purchOrderPageInfo, add, appointmentPlanCancel, detail, edit} from '../api';
import {plant, getWorkFlowLog, getAccessoryOrderStatus, cornSupplier} from "../../../../../api";

const appointmentPlan = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    plantObj: [],
    purchOrderResp: null,
    purchOrderTotal: 0,
    addObj: null,
    accessoryWork: null,
    cancleObj: null,
    detailObj: null,
    editObj: null,
    accessoryOrderStatusObj: null,
    supplierObj: null
  },
  mutations: {
    PAGE_INFO(state, data) {
      state.total = data.total;
      state.pageResp = (data.obj || []).map(item => ({...item, btns: [item.editShowFlag == 'Y' ? true : false, item.cancelShowFlag == 'Y' ? true : false, true]}));
    },
    PURCH_ORDER_PAGE_INFO(state, data) {
      state.purchOrderResp =  (data.obj || []);
      state.purchOrderTotal = data.total;
    },
    ADD(state, data) {
      state.savePurchOrderSwitchObj = data;
    },
    PLANT(state, data) {
      state.plantObj = data;
    },
    ACCESSORY_WORK(state, data) {
      state.accessoryWork = data;
    },
    CANCEL(state, data) {
      state.cancleObj = data;
    },
    DETAIL(state, data) {
      state.detailObj = data.obj;
    },
    EDIT(state, data) {
      state.editObj = data;
    },
    ACCESSORY_ORDER_STATUS(state, data) {
      state.accessoryOrderStatusObj = data;
    },
    SUPPLIER_DATA(state, data) {
      state.supplierObj = data;
    },
  },
  actions: {
    //查询事件
    async pageInfo({commit}, obj) {
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    async purchOrderPageInfo({commit}, obj){
      let result = await purchOrderPageInfo(obj);
      commit('PURCH_ORDER_PAGE_INFO', result);
    },
    async add({commit}, obj){
      let result = await add(obj);
      commit('ADD', result);
    },
    async plant({commit}, obj) {
      let resp = await plant(obj);
      commit('PLANT', resp);
    },
    //液体辅料工作流节点显示
    async getWorkFlowLog({commit}, obj){
      let resp = await getWorkFlowLog(obj);
      commit('ACCESSORY_WORK', resp);
    },
    //详情
    async detail({commit}, obj){
      let resp = await detail(obj);
      commit('DETAIL', resp);
    },
    //取消
    async appointmentPlanCancel({commit}, obj){
      let resp = await appointmentPlanCancel(obj);
      commit('CANCEL', resp);
    },
    //修改
    async edit({commit}, obj){
      let resp = await edit(obj);
      commit('EDIT', resp);
    },
    //预约状态
    async getAccessoryOrderStatus({commit}, obj){
      let resp = await getAccessoryOrderStatus(obj);
      commit('ACCESSORY_ORDER_STATUS', resp);
    },
    //供应商
    async cornSupplier({commit}, obj){
      let resp = await cornSupplier(obj);
      commit('SUPPLIER_DATA', resp);
    },
  }
}
export default appointmentPlan



// WEBPACK FOOTER //
// ./src/page/bd/accessory/appointmentPlan/store/appointmentPlan.store.js